export default __webpack_public_path__ + "static/media/23.99aacdc7.png";